import React from 'react';
import Banner from '../Components/Banner';
import CardProducto from '../Components/CardProducto';
import Testimonial from '../Components/Testimonial';
import { productos } from '../data/productos';
import { Producto } from '../types';

const Home: React.FC = () => (
  <div className="page">
    <Banner />
    <div className="section">
      <div className="container">
        <h3 className="section-title">Productos Destacados</h3>
        <div className="products-grid">
          {productos.slice(0, 3).map((producto: Producto) => (
            <CardProducto key={producto.id} {...producto} />
          ))}
        </div>
      </div>
    </div>
    <Testimonial />
  </div>
);

export default Home;
  